import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TableOperatorListComponent } from '../table-operator-list/table-operator-list.component';
import { OperatorListService } from './operator-list.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { saveAs } from 'file-saver';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-operator-list',
  templateUrl: './operator-list.component.html',
  styleUrls: ['./operator-list.component.scss'],
})
export class OperatorListComponent {
  filters = new FormGroup({
    cnpj: new FormControl<string>(''),
  });

  public isFilterColapsed = false;
  public isLoaded = false;
  public transactions: any[] = [];

  @ViewChild(TableOperatorListComponent, { static: true })
  table!: TableOperatorListComponent;

  constructor(
    private toastr: ToastrService,
    private operatorListService: OperatorListService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.buscar();
  }

  onTransactionsLoaded(lista: any[]): void {
    this.transactions = lista ?? [];
    this.isLoaded = true;
  }

  buscar(): void {
    this.isLoaded = false;

    const cnpj = (this.filters.controls.cnpj.value || '').replace(/\D/g, '');

    this.table.cnpj = cnpj;
    this.table.getTransactions();
  }

  downloadPdf(): void {
    const filters = {
      cnpj: this.filters.controls.cnpj.value || '',
    };

    this.isLoaded = false;

    this.operatorListService
      .exportPdf(filters)
      .pipe(
        finalize(() => {
          this.isLoaded = true;
        })
      )
      .subscribe({
        next: (value) => {
          const byteCharacters = atob(value);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: 'application/pdf',
          });

          saveAs(blob, `lista_operadores.pdf`);
        },
        error: () => {
          this.toastr.error('Erro ao exportar PDF.', 'Erro', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        },
      });
  }

  async paste(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();
      this.filters.controls.cnpj.setValue(text.trim());
    } catch {
      this.toastr.error('Erro ao colar conteúdo.', 'Erro', {
        timeOut: 2000,
        positionClass: 'toast-top-right',
      });
    }
  }

  filterColapse(): void {
    this.isFilterColapsed = !this.isFilterColapsed;
  }
}